// extracted by mini-css-extract-plugin
module.exports = {"label":"InputCardNameModal_label__kU2ur"};